// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { NavLink } from 'react-router-dom';
import { Enterprise, Activity } from '@carbon/icons-react';
import styles from './ProvisioningSidebar.module.css';

interface NavItem {
  label: string;
  to: string;
  icon: React.ComponentType<{ size?: number }>;
}

// Every entry needs a matching route in ProvisioningRoutes — unbuilt ones
// point at PlaceholderPage rather than dead-ending. See README.md.
const ITEMS: NavItem[] = [
  { label: 'Organizations', to: '/organizations', icon: Enterprise },
  { label: 'Runs', to: '/runs', icon: Activity },
];

const linkClassName = ({ isActive }: { isActive: boolean }) =>
  isActive ? `${styles.link} ${styles.linkActive}` : styles.link;

export default function ProvisioningSidebar() {
  return (
    <nav className={styles.sidebar} aria-label="Provisioning">
      {ITEMS.map(({ label, to, icon: Icon }) => (
        <NavLink key={to} to={to} className={linkClassName}>
          <Icon size={16} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
